import { useQuery } from 'react-query'
import { fetcher } from 'src/fetcher'
import { BASE_API_URL } from 'src/globals'
import logger from 'src/logger'

async function getServiceLineWML(serviceLineCode: string): Promise<{
    serviceLine: {
        refillApptBookingUrl: string
    }
}> {
    return fetcher(
        `${BASE_API_URL}/awell-api/open-loop/service-lines/${serviceLineCode}`,
        undefined,
        'GET',
        {
            customErrorHandler: (res: Response) => {
                res.text().then(body => {
                    logger.error(`Unexpected fetching service line.`, {
                        status: res.status,
                        errorBody: body
                    })
                })

                return new Error('Server returned not-ok')
            }
        }
    )
}

export function useServiceLine(serviceLineCode: string) {
    const query = useQuery<{
        serviceLine: {
            refillApptBookingUrl: string
        }
    }>(['open-loop-service-line'], async () => {
        return getServiceLineWML(serviceLineCode)
    })
    return {
        serviceLine: query.data?.serviceLine,
        isLoading: query.isLoading
    }
}
